var we = Object.defineProperty;
var ye = (s, e, o) => e in s ? we(s, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : s[e] = o;
var b = (s, e, o) => ye(s, typeof e != "symbol" ? e + "" : e, o);
import { Plugin as B, PluginKey as D, NodeSelection as oe, TextSelection as ne, Selection as R } from "prosemirror-state";
import { combineTransactionSteps as be, getMarkRange as ve, posToDOMRect as ke, findChildren as Y } from "@tiptap/core";
import Ce from "fast-deep-equal";
import { i as j, t as xe, U as Se, n as Ee, g as N, a as L, c as se, m as Ie, e as re, f as Pe, h as Be, j as De, k as Te, l as Oe, o as X, p as q } from "./blockToNode-BNoNIXU7.js";
import { ai as ie, aj as ae, $ as Me, a1 as W } from "./defaultBlocks-BYnRIQtu.js";
import { c as x, a as H } from "./BlockNoteExtension-C2X7LW-V.js";
import * as I from "@y/y";
import { syncPlugin as Ae } from "@y/prosemirror";
import { dropCursor as Re } from "prosemirror-dropcursor";
import { redo as Ne, undo as Le, history as Ve } from "@tiptap/pm/history";
import { Decoration as M, DecorationSet as V } from "prosemirror-view";
import { v4 as He } from "uuid";
import { DOMParser as Fe, Slice as $e } from "@tiptap/pm/model";
import { PluginKey as Ue, TextSelection as ze, Plugin as _e } from "@tiptap/pm/state";
import { DOMSerializer as le, Fragment as ce, Slice as Ke } from "prosemirror-model";
import Ye from "rehype-parse";
import je from "rehype-remark";
import Xe from "remark-gfm";
import qe from "remark-stringify";
import { unified as We } from "unified";
import { fromDom as Ge } from "hast-util-from-dom";
import { visit as Je } from "unist-util-visit";
import { splitCell as Qe, mergeCells as Ze, deleteRow as et, deleteColumn as tt, addRowBefore as ot, addRowAfter as nt, addColumnBefore as st, addColumnAfter as rt, CellSelection as it } from "prosemirror-tables";
function de(s) {
  const e = Array.from(s.classList).filter(
    (o) => !o.startsWith("bn-")
  ) || [];
  e.length > 0 ? s.className = e.join(" ") : s.removeAttribute("class");
}
function he(s, e, o, t) {
  var a;
  let n;
  if (e)
    if (typeof e == "string")
      n = j([e], s.pmSchema);
    else if (Array.isArray(e))
      n = j(e, s.pmSchema);
    else if (e.type === "tableContent")
      n = xe(e, s.pmSchema);
    else
      throw new Se(e.type);
  else throw new Error("blockContent is required");
  const i = ((t == null ? void 0 : t.document) ?? document).createDocumentFragment();
  for (const c of n)
    if (c.type.name !== "text" && s.schema.inlineContentSchema[c.type.name]) {
      const l = s.schema.inlineContentSpecs[c.type.name].implementation;
      if (l) {
        const m = Ee(
          c,
          s.schema.inlineContentSchema,
          s.schema.styleSchema
        ), u = l.toExternalHTML ? l.toExternalHTML(
          m,
          s
        ) : l.render.call(
          {
            renderType: "dom",
            props: void 0
          },
          m,
          () => {
          },
          s
        );
        if (u) {
          if (i.appendChild(u.dom), u.contentDOM) {
            const f = o.serializeFragment(
              c.content,
              t
            );
            u.contentDOM.dataset.editable = "", u.contentDOM.appendChild(f);
          }
          continue;
        }
      }
    } else if (c.type.name === "text") {
      let l = document.createTextNode(
        c.textContent
      );
      for (const m of c.marks.toReversed())
        if (m.type.name in s.schema.styleSpecs) {
          const u = (s.schema.styleSpecs[m.type.name].implementation.toExternalHTML ?? s.schema.styleSpecs[m.type.name].implementation.render)(m.attrs.stringValue, s);
          u.contentDOM.appendChild(l), l = u.dom;
        } else {
          const u = m.type.spec.toDOM(m, !0), f = le.renderSpec(document, u);
          f.contentDOM.appendChild(l), l = f.dom;
        }
      i.appendChild(l);
    } else {
      const l = o.serializeFragment(
        ce.from([c]),
        t
      );
      i.appendChild(l);
    }
  return i.childNodes.length === 1 && ((a = i.firstChild) == null ? void 0 : a.nodeType) === 1 && de(i.firstChild), i;
}
function at(s, e, o, t, n, r, i) {
  var p, w, y, E, T, U, z, _, K;
  const a = (i == null ? void 0 : i.document) ?? document, c = e.pmSchema.nodes.blockContainer, l = o.props || {};
  for (const [v, C] of Object.entries(
    e.schema.blockSchema[o.type].propSchema
  ))
    !(v in l) && C.default !== void 0 && (l[v] = C.default);
  const m = (w = (p = c.spec) == null ? void 0 : p.toDOM) == null ? void 0 : w.call(
    p,
    c.create({
      id: o.id,
      ...l
    })
  ), u = Array.from(m.dom.attributes), f = e.blockImplementations[o.type].implementation, h = ((y = f.toExternalHTML) == null ? void 0 : y.call(
    {},
    { ...o, props: l },
    e
  )) || f.render.call(
    {},
    { ...o, props: l },
    e
  ), g = a.createDocumentFragment();
  if (h.dom.classList.contains("bn-block-content")) {
    const v = [
      ...u,
      ...Array.from(h.dom.attributes)
    ].filter(
      (C) => C.name.startsWith("data") && C.name !== "data-content-type" && C.name !== "data-file-block" && C.name !== "data-node-view-wrapper" && C.name !== "data-node-type" && C.name !== "data-id" && C.name !== "data-editable"
    );
    for (const C of v)
      h.dom.firstChild.setAttribute(C.name, C.value);
    de(h.dom.firstChild), g.append(...Array.from(h.dom.childNodes));
  } else
    g.append(h.dom);
  if (h.contentDOM && o.content) {
    const v = he(
      e,
      o.content,
      // TODO
      t,
      i
    );
    h.contentDOM.appendChild(v);
  }
  let d;
  if (n.has(o.type) ? d = "OL" : r.has(o.type) && (d = "UL"), d) {
    if (((E = s.lastChild) == null ? void 0 : E.nodeName) !== d) {
      const v = a.createElement(d);
      d === "OL" && "start" in l && l.start && (l == null ? void 0 : l.start) !== 1 && v.setAttribute("start", l.start + ""), s.append(v);
    }
    s.lastChild.appendChild(g);
  } else
    s.append(g);
  if (o.children && o.children.length > 0) {
    const v = a.createDocumentFragment();
    if (ue(
      v,
      e,
      o.children,
      t,
      n,
      r,
      i
    ), ((T = s.lastChild) == null ? void 0 : T.nodeName) === "UL" || ((U = s.lastChild) == null ? void 0 : U.nodeName) === "OL")
      for (; ((z = v.firstChild) == null ? void 0 : z.nodeName) === "UL" || ((_ = v.firstChild) == null ? void 0 : _.nodeName) === "OL"; )
        s.lastChild.lastChild.appendChild(v.firstChild);
    e.pmSchema.nodes[o.type].isInGroup("blockContent") ? s.append(v) : (K = h.contentDOM) == null || K.append(v);
  }
}
const ue = (s, e, o, t, n, r, i) => {
  for (const a of o)
    at(
      s,
      e,
      a,
      t,
      n,
      r,
      i
    );
}, lt = (s, e, o, t, n, r) => {
  const a = ((r == null ? void 0 : r.document) ?? document).createDocumentFragment();
  return ue(
    a,
    s,
    e,
    o,
    t,
    n,
    r
  ), a;
}, me = (s, e) => {
  const o = le.fromSchema(s);
  return {
    exportBlocks: (t, n) => {
      const r = lt(
        e,
        t,
        o,
        /* @__PURE__ */ new Set(["numberedListItem"]),
        /* @__PURE__ */ new Set(["bulletListItem", "checkListItem", "toggleListItem"]),
        n
      ), i = document.createElement("div");
      return i.append(r), i.innerHTML;
    },
    exportInlineContent: (t, n) => {
      const r = he(
        e,
        t,
        o,
        n
      ), i = document.createElement("div");
      return i.append(r.cloneNode(!0)), i.innerHTML;
    }
  };
};
function ct(s, e) {
  if (e === 0)
    return;
  const o = s.resolve(e);
  for (let t = o.depth; t > 0; t--) {
    const n = o.node(t);
    if (ie(n))
      return n.attrs.id;
  }
}
function dt(s) {
  return s.getMeta("paste") ? { type: "paste" } : s.getMeta("uiEvent") === "drop" ? { type: "drop" } : s.getMeta("history$") ? {
    type: s.getMeta("history$").redo ? "redo" : "undo"
  } : s.getMeta("y-sync$") ? s.getMeta("y-sync$").isUndoRedoOperation ? { type: "undo-redo" } : { type: "yjs-remote" } : { type: "local" };
}
function G(s) {
  const e = "__root__", o = {}, t = {}, n = N(s);
  return s.descendants((r, i) => {
    if (!ie(r))
      return !0;
    const a = ct(s, i), c = a ?? e;
    t[c] || (t[c] = []);
    const l = L(r, n);
    return o[r.attrs.id] = { block: l, parentId: a }, t[c].push(r.attrs.id), !0;
  }), { byId: o, childrenByParent: t };
}
function ht(s, e) {
  const o = /* @__PURE__ */ new Set();
  if (!s || !e)
    return o;
  const t = new Set(s), n = e.filter((d) => t.has(d)), r = s.filter(
    (d) => n.includes(d)
  );
  if (r.length <= 1 || n.length <= 1)
    return o;
  const i = {};
  for (let d = 0; d < r.length; d++)
    i[r[d]] = d;
  const a = n.map((d) => i[d]), c = a.length, l = [], m = [], u = new Array(c).fill(-1), f = (d, p) => {
    let w = 0, y = d.length;
    for (; w < y; ) {
      const E = w + y >>> 1;
      d[E] < p ? w = E + 1 : y = E;
    }
    return w;
  };
  for (let d = 0; d < c; d++) {
    const p = a[d], w = f(l, p);
    w > 0 && (u[d] = m[w - 1]), w === l.length ? (l.push(p), m.push(d)) : (l[w] = p, m[w] = d);
  }
  const h = /* @__PURE__ */ new Set();
  let g = m[m.length - 1] ?? -1;
  for (; g !== -1; )
    h.add(g), g = u[g];
  for (let d = 0; d < n.length; d++)
    h.has(d) || o.add(n[d]);
  return o;
}
function ut(s, e = []) {
  const o = dt(s), t = be(s.before, [
    s,
    ...e
  ]), n = G(
    t.before
  ), r = G(
    t.doc
  ), i = [], a = /* @__PURE__ */ new Set();
  Object.keys(r.byId).filter((h) => !(h in n.byId)).forEach((h) => {
    i.push({
      type: "insert",
      block: r.byId[h].block,
      source: o,
      prevBlock: void 0
    }), a.add(h);
  }), Object.keys(n.byId).filter((h) => !(h in r.byId)).forEach((h) => {
    i.push({
      type: "delete",
      block: n.byId[h].block,
      source: o,
      prevBlock: void 0
    }), a.add(h);
  }), Object.keys(r.byId).filter((h) => h in n.byId).forEach((h) => {
    var w, y;
    const g = n.byId[h], d = r.byId[h];
    g.parentId !== d.parentId ? (i.push({
      type: "move",
      block: d.block,
      prevBlock: g.block,
      source: o,
      prevParent: g.parentId ? (w = n.byId[g.parentId]) == null ? void 0 : w.block : void 0,
      currentParent: d.parentId ? (y = r.byId[d.parentId]) == null ? void 0 : y.block : void 0
    }), a.add(h)) : Ce(
      { ...g.block, children: void 0 },
      { ...d.block, children: void 0 }
    ) || (i.push({
      type: "update",
      block: d.block,
      prevBlock: g.block,
      source: o
    }), a.add(h));
  });
  const c = n.childrenByParent, l = r.childrenByParent, m = "__root__", u = /* @__PURE__ */ new Set([
    ...Object.keys(c),
    ...Object.keys(l)
  ]), f = /* @__PURE__ */ new Set();
  return u.forEach((h) => {
    const g = ht(
      c[h],
      l[h]
    );
    g.size !== 0 && g.forEach((d) => {
      var E, T;
      const p = n.byId[d], w = r.byId[d];
      !p || !w || p.parentId !== w.parentId || a.has(d) || (p.parentId ?? m) !== h || f.has(d) || (f.add(d), i.push({
        type: "move",
        block: w.block,
        prevBlock: p.block,
        source: o,
        prevParent: p.parentId ? (E = n.byId[p.parentId]) == null ? void 0 : E.block : void 0,
        currentParent: w.parentId ? (T = r.byId[w.parentId]) == null ? void 0 : T.block : void 0
      }), a.add(d));
    });
  }), i;
}
const Zt = x(() => {
  const s = [];
  return {
    key: "blockChange",
    prosemirrorPlugins: [
      new B({
        key: new D("blockChange"),
        filterTransaction: (e) => {
          let o;
          return s.reduce((t, n) => t === !1 ? t : n({
            getChanges() {
              return o || (o = ut(e), o);
            },
            tr: e
          }) !== !1, !0);
        }
      })
    ],
    /**
     * Subscribe to the block change events.
     */
    subscribe(e) {
      return s.push(e), () => {
        s.splice(
          s.indexOf(e),
          1
        );
      };
    }
  };
}), F = x(
  ({
    options: s
  }) => {
    const e = Date.now();
    return {
      key: "ySync",
      prosemirrorPlugins: [
        Ae(s.fragment, {
          attributionManager: s.attributionManager,
          suggestionDoc: s.suggestionDoc,
          mapAttributionToMark(o, t) {
            var n, r, i;
            return console.log("attribution", t), console.log("format", o), t.delete ? Object.assign({}, o, {
              deletion: { id: e, user: (n = t.delete) == null ? void 0 : n[0] }
            }) : t.insert ? Object.assign({}, o, {
              insertion: { id: e, user: (r = t.insert) == null ? void 0 : r[0] }
            }) : t.format ? Object.assign({}, o, {
              insertion: { id: e, user: (i = t.format) == null ? void 0 : i[0] }
            }) : o;
          }
        })
      ],
      runsBefore: ["default"]
    };
  }
);
function mt(s, e) {
  const o = s.doc;
  if (!o)
    throw new Error("type does not have a ydoc");
  if (s._item === null) {
    const t = Array.from(o.share.keys()).find(
      (n) => o.share.get(n) === s
    );
    if (t == null)
      throw new Error("type does not exist in other ydoc");
    return e.get(t, s.constructor);
  } else {
    const t = s._item, n = e.store.clients.get(t.id.client) ?? [], r = I.findIndexSS(n, t.id.clock), i = n[r];
    if (!i)
      throw new Error("type does not exist in other ydoc");
    const a = i.content;
    if (!a)
      throw new Error("type does not exist in other ydoc");
    return a.type;
  }
}
const eo = x(
  ({ editor: s, options: e }) => {
    let o;
    const t = H({ isForked: !1 });
    return {
      key: "yForkDoc",
      store: t,
      /**
       * Fork the Y.js document from syncing to the remote,
       * allowing modifications to the document without affecting the remote.
       * These changes can later be rolled back or applied to the remote.
       */
      fork({
        /**
         * The initial update to apply to the forked document.
         */
        initialUpdate: n
      } = {}) {
        if (o)
          return;
        const r = e.fragment;
        if (!r)
          throw new Error("No fragment to fork from");
        const i = new I.Doc();
        I.applyUpdateV2(
          i,
          n ?? I.encodeStateAsUpdateV2(r.doc)
        );
        const a = mt(r, i);
        o = {
          // undoStack: yUndoPluginKey.getState(editor.prosemirrorState)!
          //   .undoManager.undoStack,
          originalFragment: r,
          forkedFragment: a
        }, s.unregisterExtension([
          // YUndoExtension,
          // YCursorExtension,
          F
        ]);
        const c = {
          ...e,
          fragment: a
        };
        s.registerExtension([
          F(c)
          // No need to register the cursor plugin again, it's a local fork
          // YUndoExtension(),
        ]), t.setState({ isForked: !0 });
      },
      /**
       * Resume syncing the Y.js document to the remote
       * If `keepChanges` is true, any changes that have been made to the forked document will be applied to the original document.
       * Otherwise, the original document will be restored and the changes will be discarded.
       */
      merge({ keepChanges: n }) {
        if (!o)
          return;
        s.unregisterExtension(["ySync", "yCursor", "yUndo"]);
        const {
          originalFragment: r,
          forkedFragment: i
          //, undoStack
        } = o;
        if (s.registerExtension([
          F(e)
          // YCursorExtension(options),
          // YUndoExtension(),
        ]), n) {
          const a = I.encodeStateAsUpdate(
            i.doc,
            I.encodeStateVector(r.doc)
          );
          I.applyUpdate(r.doc, a, s);
        }
        o = void 0, t.setState({ isForked: !1 });
      }
    };
  }
), to = x(
  ({
    editor: s,
    options: e
  }) => ({
    key: "dropCursor",
    prosemirrorPlugins: [
      (e.dropCursor ?? Re)({
        width: 5,
        color: "#ddeeff",
        editor: s
      })
    ]
  })
), oo = x(({ editor: s }) => {
  const e = H(!1), o = () => s.transact((t) => {
    var r;
    if (t.selection.empty || t.selection instanceof oe && (t.selection.node.type.spec.content === "inline*" || ((r = t.selection.node.firstChild) == null ? void 0 : r.type.spec.content) === "inline*") || t.selection instanceof ne && t.doc.textBetween(t.selection.from, t.selection.to).length === 0)
      return !1;
    let n = !1;
    return t.selection.content().content.descendants((i) => (i.type.spec.code && (n = !0), !n)), !n;
  });
  return {
    key: "formattingToolbar",
    store: e,
    mount({ dom: t, signal: n }) {
      let r = !1;
      const i = s.onChange(() => {
        r || e.setState(o());
      }), a = s.onSelectionChange(() => {
        r || e.setState(o());
      });
      t.addEventListener(
        "pointerdown",
        () => {
          r = !0, e.setState(!1);
        },
        { signal: n }
      ), s.prosemirrorView.root.addEventListener(
        "pointerup",
        () => {
          r = !1, s.isFocused() && e.setState(o());
        },
        { signal: n, capture: !0 }
      ), t.addEventListener(
        "pointercancel",
        () => {
          r = !1;
        },
        {
          signal: n,
          capture: !0
        }
      ), n.addEventListener("abort", () => {
        i(), a();
      });
    }
  };
}), no = x(() => ({
  key: "history",
  prosemirrorPlugins: [Ve()],
  undoCommand: Le,
  redoCommand: Ne
})), so = x(({ editor: s }) => {
  function e(n) {
    let r = s.prosemirrorView.nodeDOM(n);
    for (; r && r.parentElement; ) {
      if (r.nodeName === "A")
        return r;
      r = r.parentElement;
    }
    return null;
  }
  function o(n, r) {
    return s.transact((i) => {
      const a = i.doc.resolve(n), c = a.marks().find((m) => m.type.name === r);
      if (!c)
        return;
      const l = ve(a, c.type);
      if (l)
        return {
          range: l,
          mark: c,
          get text() {
            return i.doc.textBetween(l.from, l.to);
          },
          get position() {
            return ke(
              s.prosemirrorView,
              l.from,
              l.to
            ).toJSON();
          }
        };
    });
  }
  function t() {
    return s.transact((n) => {
      const r = n.selection;
      if (r.empty)
        return o(r.anchor, "link");
    });
  }
  return {
    key: "linkToolbar",
    getLinkAtSelection: t,
    getLinkElementAtPos: e,
    getMarkAtPos: o,
    getLinkAtCoords(n) {
      return s.transact(() => {
        const r = s.prosemirrorView.posAtCoords(n);
        if (!(r === null || r.inside === -1))
          return o(r.pos, "link");
      });
    },
    editLink(n, r, i = s.transact((a) => a.selection.anchor)) {
      s.transact((a) => {
        const c = N(a), { range: l } = o(i + 1, "link") || {
          range: {
            from: a.selection.from,
            to: a.selection.to
          }
        };
        l && (a.insertText(r, l.from, l.to), a.addMark(
          l.from,
          l.from + r.length,
          c.mark("link", { href: n })
        ));
      }), s.prosemirrorView.focus();
    },
    deleteLink(n = s.transact((r) => r.selection.anchor)) {
      s.transact((r) => {
        const i = N(r), { range: a } = o(n + 1, "link") || {
          range: {
            from: r.selection.from,
            to: r.selection.to
          }
        };
        a && r.removeMark(a.from, a.to, i.marks.link).setMeta(
          "preventAutolink",
          !0
        );
      }), s.prosemirrorView.focus();
    }
  };
}), ro = [
  "http",
  "https",
  "ftp",
  "ftps",
  "mailto",
  "tel",
  "callto",
  "sms",
  "cid",
  "xmpp"
], io = "https", pt = new D("node-selection-keyboard"), ao = x(
  () => ({
    key: "nodeSelectionKeyboard",
    prosemirrorPlugins: [
      new B({
        key: pt,
        props: {
          handleKeyDown: (s, e) => {
            if ("node" in s.state.selection) {
              if (e.ctrlKey || e.metaKey)
                return !1;
              if (e.key.length === 1)
                return e.preventDefault(), !0;
              if (e.key === "Enter" && !e.shiftKey && !e.altKey && !e.ctrlKey && !e.metaKey) {
                const o = s.state.tr;
                return s.dispatch(
                  o.insert(
                    s.state.tr.selection.$to.after(),
                    s.state.schema.nodes.paragraph.createChecked()
                  ).setSelection(
                    new ne(
                      o.doc.resolve(
                        s.state.tr.selection.$to.after() + 1
                      )
                    )
                  )
                ), !0;
              }
            }
            return !1;
          }
        }
      })
    ]
  })
), ft = new D("blocknote-placeholder"), lo = x(
  ({
    editor: s,
    options: e
  }) => {
    const o = e.placeholders;
    return {
      key: "placeholder",
      prosemirrorPlugins: [
        new B({
          key: ft,
          view: (t) => {
            const n = `placeholder-selector-${He()}`;
            t.dom.classList.add(n);
            const r = document.createElement("style"), i = s._tiptapEditor.options.injectNonce;
            i && r.setAttribute("nonce", i), t.root instanceof window.ShadowRoot ? t.root.append(r) : t.root.head.appendChild(r);
            const a = r.sheet, c = (l = "") => `.${n} .bn-block-content${l} .bn-inline-content:has(> .ProseMirror-trailingBreak:only-child):before`;
            try {
              const {
                default: l,
                emptyDocument: m,
                ...u
              } = o || {};
              for (const [g, d] of Object.entries(u)) {
                const p = `[data-content-type="${g}"]`;
                a.insertRule(
                  `${c(p)} { content: ${JSON.stringify(
                    d
                  )}; }`
                );
              }
              const f = "[data-is-only-empty-block]", h = "[data-is-empty-and-focused]";
              a.insertRule(
                `${c(f)} { content: ${JSON.stringify(
                  m
                )}; }`
              ), a.insertRule(
                `${c(h)} { content: ${JSON.stringify(
                  l
                )}; }`
              );
            } catch (l) {
              console.warn(
                "Failed to insert placeholder CSS rule - this is likely due to the browser not supporting certain CSS pseudo-element selectors (:has, :only-child:, or :before)",
                l
              );
            }
            return {
              destroy: () => {
                t.root instanceof window.ShadowRoot ? t.root.removeChild(r) : t.root.head.removeChild(r);
              }
            };
          },
          props: {
            decorations: (t) => {
              const { doc: n, selection: r } = t;
              if (!s.isEditable || !r.empty || r.$from.parent.type.spec.code)
                return;
              const i = [];
              t.doc.content.size === 6 && i.push(
                M.node(2, 4, {
                  "data-is-only-empty-block": "true"
                })
              );
              const a = r.$anchor, c = a.parent;
              if (c.content.size === 0) {
                const l = a.before();
                i.push(
                  M.node(l, l + c.nodeSize, {
                    "data-is-empty-and-focused": "true"
                  })
                );
              }
              return V.create(n, i);
            }
          }
        })
      ]
    };
  }
), J = new D("previous-blocks"), gt = {
  // Numbered List Items
  index: "index",
  // Headings
  level: "level",
  // All Blocks
  type: "type",
  depth: "depth",
  "depth-change": "depth-change"
}, co = x(() => {
  let s;
  return {
    key: "previousBlockType",
    prosemirrorPlugins: [
      new B({
        key: J,
        view(e) {
          return {
            update: async (o, t) => {
              var n;
              ((n = this.key) == null ? void 0 : n.getState(o.state).updatedBlocks.size) > 0 && (s = setTimeout(() => {
                o.dispatch(
                  o.state.tr.setMeta(J, { clearUpdate: !0 })
                );
              }, 0));
            },
            destroy: () => {
              s && clearTimeout(s);
            }
          };
        },
        state: {
          init() {
            return {
              // Block attributes, by block ID, from just before the previous transaction.
              prevTransactionOldBlockAttrs: {},
              // Block attributes, by block ID, from just before the current transaction.
              currentTransactionOldBlockAttrs: {},
              // Set of IDs of blocks whose attributes changed from the current transaction.
              updatedBlocks: /* @__PURE__ */ new Set()
            };
          },
          apply(e, o, t, n) {
            if (o.currentTransactionOldBlockAttrs = {}, o.updatedBlocks.clear(), !e.docChanged || t.doc.eq(n.doc))
              return o;
            const r = {}, i = Y(
              t.doc,
              (l) => l.attrs.id
            ), a = new Map(
              i.map((l) => [l.node.attrs.id, l])
            ), c = Y(
              n.doc,
              (l) => l.attrs.id
            );
            for (const l of c) {
              const m = a.get(l.node.attrs.id), u = m == null ? void 0 : m.node.firstChild, f = l.node.firstChild;
              if (m && u && f) {
                const h = {
                  index: f.attrs.index,
                  level: f.attrs.level,
                  type: f.type.name,
                  depth: n.doc.resolve(l.pos).depth
                }, g = {
                  index: u.attrs.index,
                  level: u.attrs.level,
                  type: u.type.name,
                  depth: t.doc.resolve(m.pos).depth
                };
                r[l.node.attrs.id] = g, o.currentTransactionOldBlockAttrs[l.node.attrs.id] = g, JSON.stringify(g) !== JSON.stringify(h) && (g["depth-change"] = g.depth - h.depth, o.updatedBlocks.add(l.node.attrs.id));
              }
            }
            return o.prevTransactionOldBlockAttrs = r, o;
          }
        },
        props: {
          decorations(e) {
            const o = this.getState(e);
            if (o.updatedBlocks.size === 0)
              return;
            const t = [];
            return e.doc.descendants((n, r) => {
              if (!n.attrs.id || !o.updatedBlocks.has(n.attrs.id))
                return;
              const i = o.currentTransactionOldBlockAttrs[n.attrs.id], a = {};
              for (const [l, m] of Object.entries(i))
                a["data-prev-" + gt[l]] = m || "none";
              const c = M.node(r, r + n.nodeSize, {
                ...a
              });
              t.push(c);
            }), V.create(e.doc, t);
          }
        }
      })
    ]
  };
});
function pe(s, e) {
  var o, t;
  for (; s && s.parentElement && s.parentElement !== e.dom && ((o = s.getAttribute) == null ? void 0 : o.call(s, "data-node-type")) !== "blockContainer"; )
    s = s.parentElement;
  if (((t = s.getAttribute) == null ? void 0 : t.call(s, "data-node-type")) === "blockContainer")
    return { node: s, id: s.getAttribute("data-id") };
}
function wt() {
  const s = (e) => {
    let o = e.children.length;
    for (let t = 0; t < o; t++) {
      const n = e.children[t];
      if (n.type === "element" && (s(n), n.tagName === "u"))
        if (n.children.length > 0) {
          e.children.splice(t, 1, ...n.children);
          const r = n.children.length - 1;
          o += r, t += r;
        } else
          e.children.splice(t, 1), o--, t--;
    }
  };
  return s;
}
function yt() {
  const s = (e) => {
    var o;
    if (e.children && "length" in e.children && e.children.length)
      for (let t = e.children.length - 1; t >= 0; t--) {
        const n = e.children[t], r = t + 1 < e.children.length ? e.children[t + 1] : void 0;
        n.type === "element" && n.tagName === "input" && ((o = n.properties) == null ? void 0 : o.type) === "checkbox" && (r == null ? void 0 : r.type) === "element" && r.tagName === "p" ? (r.tagName = "span", r.children.splice(
          0,
          0,
          Ge(document.createTextNode(" "))
        )) : s(n);
      }
  };
  return s;
}
function bt() {
  return (s) => {
    Je(s, "element", (e, o, t) => {
      var n, r, i, a;
      if (t && e.tagName === "video") {
        const c = ((n = e.properties) == null ? void 0 : n.src) || ((r = e.properties) == null ? void 0 : r["data-url"]) || "", l = ((i = e.properties) == null ? void 0 : i.title) || ((a = e.properties) == null ? void 0 : a["data-name"]) || "";
        t.children[o] = {
          type: "text",
          value: `![${l}](${c})`
        };
      }
    });
  };
}
function fe(s) {
  return We().use(Ye, { fragment: !0 }).use(bt).use(wt).use(yt).use(je).use(Xe).use(qe, {
    handlers: { text: (o) => o.value }
  }).processSync(s).value;
}
function ho(s, e, o, t) {
  const r = me(e, o).exportBlocks(s, t);
  return fe(r);
}
function vt(s) {
  const e = [];
  return s.descendants((o) => {
    var n, r;
    const t = N(o);
    return o.type.name === "blockContainer" && ((n = o.firstChild) == null ? void 0 : n.type.name) === "blockGroup" ? !0 : o.type.name === "columnList" && o.childCount === 1 ? ((r = o.firstChild) == null || r.forEach((i) => {
      e.push(L(i, t));
    }), !1) : o.type.isInGroup("bnBlock") ? (e.push(L(o, t)), !1) : !0;
  }), e;
}
class P extends R {
  constructor(o, t) {
    super(o, t);
    b(this, "nodes");
    const n = o.node();
    this.nodes = [], o.doc.nodesBetween(o.pos, t.pos, (r, i, a) => {
      if (a !== null && a.eq(n))
        return this.nodes.push(r), !1;
    });
  }
  static create(o, t, n = t) {
    return new P(o.resolve(t), o.resolve(n));
  }
  content() {
    return new Ke(ce.from(this.nodes), 0, 0);
  }
  eq(o) {
    if (!(o instanceof P) || this.nodes.length !== o.nodes.length || this.from !== o.from || this.to !== o.to)
      return !1;
    for (let t = 0; t < this.nodes.length; t++)
      if (!this.nodes[t].eq(o.nodes[t]))
        return !1;
    return !0;
  }
  map(o, t) {
    const n = t.mapResult(this.from), r = t.mapResult(this.to);
    return r.deleted ? R.near(o.resolve(n.pos)) : n.deleted ? R.near(o.resolve(r.pos)) : new P(
      o.resolve(n.pos),
      o.resolve(r.pos)
    );
  }
  toJSON() {
    return { type: "multiple-node", anchor: this.anchor, head: this.head };
  }
}
R.jsonID("multiple-node", P);
let S;
function kt(s, e) {
  let o, t;
  const n = e.resolve(s.from).node().type.spec.group === "blockContent", r = e.resolve(s.to).node().type.spec.group === "blockContent", i = Math.min(s.$anchor.depth, s.$head.depth);
  if (n && r) {
    const a = s.$from.start(i - 1), c = s.$to.end(i - 1);
    o = e.resolve(a - 1).pos, t = e.resolve(c + 1).pos;
  } else
    o = s.from, t = s.to;
  return { from: o, to: t };
}
function Q(s, e, o = e) {
  e === o && (o += s.state.doc.resolve(e + 1).node().nodeSize);
  const t = s.domAtPos(e).node.cloneNode(!0), n = s.domAtPos(e).node, r = (u, f) => Array.prototype.indexOf.call(u.children, f), i = r(
    n,
    // Expects from position to be just before the first selected block.
    s.domAtPos(e + 1).node.parentElement
  ), a = r(
    n,
    // Expects to position to be just after the last selected block.
    s.domAtPos(o - 1).node.parentElement
  );
  for (let u = n.childElementCount - 1; u >= 0; u--)
    (u > a || u < i) && t.removeChild(t.children[u]);
  ge(s.root), S = t;
  const c = S.getElementsByTagName("iframe");
  for (let u = 0; u < c.length; u++) {
    const f = c[u], h = f.parentElement;
    h && h.removeChild(f);
  }
  const m = s.dom.className.split(" ").filter(
    (u) => u !== "ProseMirror" && u !== "bn-root" && u !== "bn-editor"
  ).join(" ");
  S.className = S.className + " bn-drag-preview " + m, s.root instanceof ShadowRoot ? s.root.appendChild(S) : s.root.body.appendChild(S);
}
function ge(s) {
  S !== void 0 && (s instanceof ShadowRoot ? s.removeChild(S) : s.body.removeChild(S), S = void 0);
}
function Ct(s, e, o) {
  if (!s.dataTransfer || o.headless)
    return;
  const t = o.prosemirrorView, n = ae(e.id, t.state.doc);
  if (!n)
    throw new Error(`Block with ID ${e.id} not found`);
  const r = n.posBeforeNode;
  if (r != null) {
    const i = t.state.selection, a = t.state.doc, { from: c, to: l } = kt(i, a), m = c <= r && r < l, u = i.$anchor.node() !== i.$head.node() || i instanceof P;
    m && u ? (t.dispatch(
      t.state.tr.setSelection(P.create(a, c, l))
    ), Q(t, c, l)) : (t.dispatch(
      t.state.tr.setSelection(oe.create(t.state.doc, r))
    ), Q(t, r));
    const f = t.state.selection.content(), h = o.pmSchema, g = t.serializeForClipboard(f).dom.innerHTML, d = me(h, o), p = vt(f.content), w = d.exportBlocks(p, {}), y = fe(w);
    s.dataTransfer.clearData(), s.dataTransfer.setData("blocknote/html", g), s.dataTransfer.setData("text/html", w), s.dataTransfer.setData("text/plain", y), s.dataTransfer.effectAllowed = "move", s.dataTransfer.setDragImage(S, 0, 0);
  }
}
const Z = 250;
function $(s, e, o = !0) {
  const t = s.root.elementsFromPoint(e.left, e.top);
  for (const n of t)
    if (s.dom.contains(n))
      return o && n.closest("[data-node-type=columnList]") ? $(
        s,
        {
          // TODO can we do better than this?
          left: e.left + 50,
          // bit hacky, but if we're inside a column, offset x position to right to account for the width of sidemenu itself
          top: e.top
        },
        !1
      ) : pe(n, s);
}
function xt(s, e) {
  if (!e.dom.firstChild)
    return;
  const o = e.dom.firstChild.getBoundingClientRect(), t = {
    // Clamps the x position to the editor's bounding box.
    left: Math.min(
      Math.max(o.left + 10, s.x),
      o.right - 10
    ),
    top: s.y
  }, n = $(e, t);
  if (!n)
    return;
  const r = n.node.getBoundingClientRect();
  return $(
    e,
    {
      left: r.right - 10,
      top: s.y
    },
    !1
  );
}
class St {
  constructor(e, o, t) {
    b(this, "state");
    b(this, "emitUpdate");
    b(this, "mousePos");
    b(this, "hoveredBlock");
    b(this, "menuFrozen", !1);
    b(this, "isDragOrigin", !1);
    b(this, "updateState", (e) => {
      this.state = e, this.emitUpdate(this.state);
    });
    b(this, "updateStateFromMousePos", () => {
      var t, n, r, i, a;
      if (this.menuFrozen || !this.mousePos)
        return;
      const e = this.findClosestEditorElement({
        clientX: this.mousePos.x,
        clientY: this.mousePos.y
      });
      if ((e == null ? void 0 : e.element) !== this.pmView.dom || e.distance > Z) {
        (t = this.state) != null && t.show && (this.state.show = !1, this.updateState(this.state));
        return;
      }
      const o = xt(this.mousePos, this.pmView);
      if (!o || !this.editor.isEditable) {
        (n = this.state) != null && n.show && (this.state.show = !1, this.updateState(this.state));
        return;
      }
      if (!((r = this.state) != null && r.show && ((i = this.hoveredBlock) != null && i.hasAttribute("data-id")) && ((a = this.hoveredBlock) == null ? void 0 : a.getAttribute("data-id")) === o.id) && (this.hoveredBlock = o.node, this.editor.isEditable)) {
        const c = o.node.getBoundingClientRect(), l = o.node.closest("[data-node-type=column]");
        this.state = {
          show: !0,
          referencePos: new DOMRect(
            l ? (
              // We take the first child as column elements have some default
              // padding. This is a little weird since this child element will
              // be the first block, but since it's always non-nested and we
              // only take the x coordinate, it's ok.
              l.firstElementChild.getBoundingClientRect().x
            ) : this.pmView.dom.firstChild.getBoundingClientRect().x,
            c.y,
            c.width,
            c.height
          ),
          block: this.editor.getBlock(
            this.hoveredBlock.getAttribute("data-id")
          )
        }, this.updateState(this.state);
      }
    });
    /**
     * If a block is being dragged, ProseMirror usually gets the context of what's
     * being dragged from `view.dragging`, which is automatically set when a
     * `dragstart` event fires in the editor. However, if the user tries to drag
     * and drop blocks between multiple editors, only the one in which the drag
     * began has that context, so we need to set it on the others manually. This
     * ensures that PM always drops the blocks in between other blocks, and not
     * inside them.
     *
     * After the `dragstart` event fires on the drag handle, it sets
     * `blocknote/html` data on the clipboard. This handler fires right after,
     * parsing the `blocknote/html` data into nodes and setting them on
     * `view.dragging`.
     *
     * Note: Setting `view.dragging` on `dragover` would be better as the user
     * could then drag between editors in different windows, but you can only
     * access `dataTransfer` contents on `dragstart` and `drop` events.
     */
    b(this, "onDragStart", (e) => {
      var i;
      const o = (i = e.dataTransfer) == null ? void 0 : i.getData("blocknote/html");
      if (!o || this.pmView.dragging)
        return;
      const t = document.createElement("div");
      t.innerHTML = o;
      const r = Fe.fromSchema(this.pmView.state.schema).parse(t, {
        topNode: this.pmView.state.schema.nodes.blockGroup.create()
      });
      this.pmView.dragging = {
        slice: new $e(r.content, 0, 0),
        move: !0
      };
    });
    /**
     * Finds the closest editor visually to the given coordinates
     */
    b(this, "findClosestEditorElement", (e) => {
      const o = Array.from(this.pmView.root.querySelectorAll(".bn-editor"));
      if (o.length === 0)
        return null;
      let t = o[0], n = Number.MAX_VALUE;
      return o.forEach((r) => {
        const i = r.querySelector(".bn-block-group").getBoundingClientRect(), a = e.clientX < i.left ? i.left - e.clientX : e.clientX > i.right ? e.clientX - i.right : 0, c = e.clientY < i.top ? i.top - e.clientY : e.clientY > i.bottom ? e.clientY - i.bottom : 0, l = Math.sqrt(
          Math.pow(a, 2) + Math.pow(c, 2)
        );
        l < n && (n = l, t = r);
      }), {
        element: t,
        distance: n
      };
    });
    /**
     * This dragover event handler listens at the document level,
     * and is trying to handle dragover events for all editors.
     *
     * It specifically is trying to handle the following cases:
     *  - If the dragover event is within the bounds of any editor, then it does nothing
     *  - If the dragover event is outside the bounds of any editor, but close enough (within DISTANCE_TO_CONSIDER_EDITOR_BOUNDS) to the closest editor,
     *    then it dispatches a synthetic dragover event to the closest editor (which will trigger the drop-cursor to be shown on that editor)
     *  - If the dragover event is outside the bounds of the current editor, then it will dispatch a synthetic dragleave event to the current editor
     *    (which will trigger the drop-cursor to be removed from the current editor)
     *
     * The synthetic event is a necessary evil because we do not control prosemirror-dropcursor to be able to show the drop-cursor within the range we want
     */
    b(this, "onDragOver", (e) => {
      if (e.synthetic)
        return;
      const o = this.getDragEventContext(e);
      if (!o || !o.isDropPoint) {
        this.closeDropCursor();
        return;
      }
      o.isDropPoint && !o.isDropWithinEditorBounds && this.dispatchSyntheticEvent(e);
    });
    /**
     * Closes the drop-cursor for the current editor
     */
    b(this, "closeDropCursor", () => {
      const e = new Event("dragleave", { bubbles: !1 });
      e.synthetic = !0, this.pmView.dom.dispatchEvent(e);
    });
    /**
     * It is surprisingly difficult to determine the information we need to know about a drag event
     *
     * This function is trying to determine the following:
     *  - Whether the current editor instance is the drop point
     *  - Whether the current editor instance is the drag origin
     *  - Whether the drop event is within the bounds of the current editor instance
     */
    b(this, "getDragEventContext", (e) => {
      var c;
      const o = !((c = e.dataTransfer) != null && c.types.includes("blocknote/html")) && !!this.pmView.dragging, t = !!this.isDragOrigin, n = o || t, r = this.findClosestEditorElement(e);
      if (!r || r.distance > Z)
        return;
      const i = r.element === this.pmView.dom, a = i && r.distance === 0;
      if (!(!i && !n))
        return {
          isDropPoint: i,
          isDropWithinEditorBounds: a,
          isDragOrigin: n
        };
    });
    /**
     * The drop event handler listens at the document level,
     * and handles drop events for all editors.
     *
     * It specifically handles the following cases:
     *  - If we are both the drag origin and drop point:
     *    - Let normal drop handling take over
     *  - If we are the drop point but not the drag origin:
     *    - Collapse selection to prevent PM from deleting unrelated content
     *    - If drop event is outside our editor bounds, dispatch synthetic drop event to our editor
     *  - If we are the drag origin but not the drop point:
     *    - Delete the dragged content from our editor after a delay
     */
    b(this, "onDrop", (e) => {
      if (e.synthetic)
        return;
      const o = this.getDragEventContext(e);
      if (!o) {
        this.closeDropCursor();
        return;
      }
      const { isDropPoint: t, isDropWithinEditorBounds: n, isDragOrigin: r } = o;
      if (!n && t && this.dispatchSyntheticEvent(e), t) {
        if (this.pmView.dragging)
          return;
        this.pmView.dispatch(
          this.pmView.state.tr.setSelection(
            ze.create(
              this.pmView.state.tr.doc,
              this.pmView.state.tr.selection.anchor
            )
          )
        );
        return;
      } else if (r) {
        setTimeout(
          () => this.pmView.dispatch(this.pmView.state.tr.deleteSelection()),
          0
        );
        return;
      }
    });
    b(this, "onDragEnd", (e) => {
      e.synthetic || (this.pmView.dragging = null);
    });
    b(this, "onKeyDown", (e) => {
      var o;
      (o = this.state) != null && o.show && this.editor.isFocused() && (this.state.show = !1, this.emitUpdate(this.state));
    });
    b(this, "onMouseMove", (e) => {
      var r;
      if (this.menuFrozen)
        return;
      this.mousePos = { x: e.clientX, y: e.clientY };
      const o = this.pmView.dom.getBoundingClientRect(), t = this.mousePos.x > o.left && this.mousePos.x < o.right && this.mousePos.y > o.top && this.mousePos.y < o.bottom, n = this.pmView.dom.parentElement;
      if (
        // Cursor is within the editor area
        t && // An element is hovered
        e && e.target && // Element is outside the editor
        !(n === e.target || n.contains(e.target))
      ) {
        (r = this.state) != null && r.show && (this.state.show = !1, this.emitUpdate(this.state));
        return;
      }
      this.updateStateFromMousePos();
    });
    this.editor = e, this.pmView = o, this.emitUpdate = () => {
      if (!this.state)
        throw new Error("Attempting to update uninitialized side menu");
      t(this.state);
    }, this.pmView.root.addEventListener(
      "dragstart",
      this.onDragStart
    ), this.pmView.root.addEventListener(
      "dragover",
      this.onDragOver
    ), this.pmView.root.addEventListener(
      "drop",
      this.onDrop,
      !0
    ), this.pmView.root.addEventListener(
      "dragend",
      this.onDragEnd,
      !0
    ), this.pmView.root.addEventListener(
      "mousemove",
      this.onMouseMove,
      !0
    ), this.pmView.root.addEventListener(
      "keydown",
      this.onKeyDown,
      !0
    );
  }
  dispatchSyntheticEvent(e) {
    const o = new Event(e.type, e), t = this.pmView.dom.firstChild.getBoundingClientRect();
    o.clientX = e.clientX, o.clientY = e.clientY, o.clientX = Math.min(
      Math.max(e.clientX, t.left),
      t.left + t.width
    ), o.clientY = Math.min(
      Math.max(e.clientY, t.top),
      t.top + t.height
    ), o.dataTransfer = e.dataTransfer, o.preventDefault = () => e.preventDefault(), o.synthetic = !0, this.pmView.dom.dispatchEvent(o);
  }
  // Needed in cases where the editor state updates without the mouse cursor
  // moving, as some state updates can require a side menu update. For example,
  // adding a button to the side menu which removes the block can cause the
  // block below to jump up into the place of the removed block when clicked,
  // allowing the user to click the button again without moving the cursor. This
  // would otherwise not update the side menu, and so clicking the button again
  // would attempt to remove the same block again, causing an error.
  update(e, o) {
    var n;
    !o.doc.eq(this.pmView.state.doc) && ((n = this.state) != null && n.show) && this.updateStateFromMousePos();
  }
  destroy() {
    var e;
    (e = this.state) != null && e.show && (this.state.show = !1, this.emitUpdate(this.state)), this.pmView.root.removeEventListener(
      "mousemove",
      this.onMouseMove,
      !0
    ), this.pmView.root.removeEventListener(
      "dragstart",
      this.onDragStart
    ), this.pmView.root.removeEventListener(
      "dragover",
      this.onDragOver
    ), this.pmView.root.removeEventListener(
      "drop",
      this.onDrop,
      !0
    ), this.pmView.root.removeEventListener(
      "dragend",
      this.onDragEnd,
      !0
    ), this.pmView.root.removeEventListener(
      "keydown",
      this.onKeyDown,
      !0
    );
  }
}
const Et = new Ue("SideMenuPlugin"), uo = x(({ editor: s }) => {
  let e;
  const o = H(
    void 0
  );
  return {
    key: "sideMenu",
    store: o,
    prosemirrorPlugins: [
      new _e({
        key: Et,
        view: (t) => (e = new St(s, t, (n) => {
          o.setState({ ...n });
        }), e)
      })
    ],
    /**
     * Handles drag & drop events for blocks.
     */
    blockDragStart(t, n) {
      e && (e.isDragOrigin = !0), Ct(t, n, s);
    },
    /**
     * Handles drag & drop events for blocks.
     */
    blockDragEnd() {
      ge(s.prosemirrorView.root), e && (e.isDragOrigin = !1), s.blur();
    },
    /**
     * Freezes the side menu. When frozen, the side menu will stay
     * attached to the same block regardless of which block is hovered by the
     * mouse cursor.
     */
    freezeMenu() {
      e.menuFrozen = !0, e.state.show = !0, e.emitUpdate(e.state);
    },
    /**
     * Unfreezes the side menu. When frozen, the side menu will stay
     * attached to the same block regardless of which block is hovered by the
     * mouse cursor.
     */
    unfreezeMenu() {
      e.menuFrozen = !1, e.state.show = !1, e.emitUpdate(e.state);
    }
  };
});
let k;
function ee(s) {
  k || (k = document.createElement("div"), k.innerHTML = "_", k.style.opacity = "0", k.style.height = "1px", k.style.width = "1px", s instanceof Document ? s.body.appendChild(k) : s.appendChild(k));
}
function It(s) {
  k && (s instanceof Document ? s.body.removeChild(k) : s.removeChild(k), k = void 0);
}
function A(s) {
  return Array.prototype.indexOf.call(s.parentElement.childNodes, s);
}
function Pt(s) {
  let e = s;
  for (; e && e.nodeName !== "TD" && e.nodeName !== "TH" && !e.classList.contains("tableWrapper"); ) {
    if (e.classList.contains("ProseMirror"))
      return;
    const o = e.parentNode;
    if (!o || !(o instanceof Element))
      return;
    e = o;
  }
  return e.nodeName === "TD" || e.nodeName === "TH" ? {
    type: "cell",
    domNode: e,
    tbodyNode: e.closest("tbody")
  } : {
    type: "wrapper",
    domNode: e,
    tbodyNode: e.querySelector("tbody")
  };
}
function Bt(s, e) {
  const o = e.querySelectorAll(s);
  for (let t = 0; t < o.length; t++)
    o[t].style.visibility = "hidden";
}
class Dt {
  constructor(e, o, t) {
    b(this, "state");
    b(this, "emitUpdate");
    b(this, "tableId");
    b(this, "tablePos");
    b(this, "tableElement");
    b(this, "menuFrozen", !1);
    b(this, "mouseState", "up");
    b(this, "prevWasEditable", null);
    b(this, "viewMousedownHandler", () => {
      this.mouseState = "down";
    });
    b(this, "mouseUpHandler", (e) => {
      this.mouseState = "up", this.mouseMoveHandler(e);
    });
    b(this, "mouseMoveHandler", (e) => {
      var l, m, u, f, h, g, d;
      if (this.menuFrozen || this.mouseState === "selecting" || !(e.target instanceof Element) || !this.pmView.dom.contains(e.target))
        return;
      const o = Pt(e.target);
      if ((o == null ? void 0 : o.type) === "cell" && this.mouseState === "down" && !((l = this.state) != null && l.draggingState)) {
        this.mouseState = "selecting", (m = this.state) != null && m.show && (this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate());
        return;
      }
      if (!o || !this.editor.isEditable) {
        (u = this.state) != null && u.show && (this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate());
        return;
      }
      if (!o.tbodyNode)
        return;
      const t = o.tbodyNode.getBoundingClientRect(), n = pe(o.domNode, this.pmView);
      if (!n)
        return;
      this.tableElement = n.node;
      let r;
      const i = this.editor.transact(
        (p) => ae(n.id, p.doc)
      );
      if (!i)
        throw new Error(`Block with ID ${n.id} not found`);
      const a = L(
        i.node,
        this.editor.pmSchema,
        this.editor.schema.blockSchema,
        this.editor.schema.inlineContentSchema,
        this.editor.schema.styleSchema
      );
      if (Me(this.editor, "table") && (this.tablePos = i.posBeforeNode + 1, r = a), !r)
        return;
      this.tableId = n.id;
      const c = (f = o.domNode.closest(".tableWrapper")) == null ? void 0 : f.querySelector(".table-widgets-container");
      if ((o == null ? void 0 : o.type) === "wrapper") {
        const p = e.clientY >= t.bottom - 1 && // -1 to account for fractions of pixels in "bottom"
        e.clientY < t.bottom + 20, w = e.clientX >= t.right - 1 && e.clientX < t.right + 20, y = e.clientX > t.right || e.clientY > t.bottom;
        this.state = {
          ...this.state,
          show: !0,
          showAddOrRemoveRowsButton: p,
          showAddOrRemoveColumnsButton: w,
          referencePosTable: t,
          block: r,
          widgetContainer: c,
          colIndex: y || (h = this.state) == null ? void 0 : h.colIndex,
          rowIndex: y || (g = this.state) == null ? void 0 : g.rowIndex,
          referencePosCell: y || (d = this.state) == null ? void 0 : d.referencePosCell
        };
      } else {
        const p = A(o.domNode), w = A(o.domNode.parentElement), y = o.domNode.getBoundingClientRect();
        if (this.state !== void 0 && this.state.show && this.tableId === n.id && this.state.rowIndex === w && this.state.colIndex === p)
          return;
        this.state = {
          show: !0,
          showAddOrRemoveColumnsButton: p === r.content.rows[0].cells.length - 1,
          showAddOrRemoveRowsButton: w === r.content.rows.length - 1,
          referencePosTable: t,
          block: r,
          draggingState: void 0,
          referencePosCell: y,
          colIndex: p,
          rowIndex: w,
          widgetContainer: c
        };
      }
      return this.emitUpdate(), !1;
    });
    b(this, "dragOverHandler", (e) => {
      var f;
      if (((f = this.state) == null ? void 0 : f.draggingState) === void 0)
        return;
      e.preventDefault(), e.dataTransfer.dropEffect = "move", Bt(
        ".prosemirror-dropcursor-block, .prosemirror-dropcursor-inline",
        this.pmView.root
      );
      const o = {
        left: Math.min(
          Math.max(e.clientX, this.state.referencePosTable.left + 1),
          this.state.referencePosTable.right - 1
        ),
        top: Math.min(
          Math.max(e.clientY, this.state.referencePosTable.top + 1),
          this.state.referencePosTable.bottom - 1
        )
      }, t = this.pmView.root.elementsFromPoint(o.left, o.top).filter(
        (h) => h.tagName === "TD" || h.tagName === "TH"
      );
      if (t.length === 0)
        return;
      const n = t[0];
      let r = !1;
      const i = A(n.parentElement), a = A(n), c = this.state.draggingState.draggedCellOrientation === "row" ? this.state.rowIndex : this.state.colIndex, m = (this.state.draggingState.draggedCellOrientation === "row" ? i : a) !== c;
      (this.state.rowIndex !== i || this.state.colIndex !== a) && (this.state.rowIndex = i, this.state.colIndex = a, this.state.referencePosCell = n.getBoundingClientRect(), r = !0);
      const u = this.state.draggingState.draggedCellOrientation === "row" ? o.top : o.left;
      this.state.draggingState.mousePos !== u && (this.state.draggingState.mousePos = u, r = !0), r && this.emitUpdate(), m && this.editor.transact((h) => h.setMeta(O, !0));
    });
    b(this, "dropHandler", (e) => {
      if (this.mouseState = "up", this.state === void 0 || this.state.draggingState === void 0)
        return !1;
      if (this.state.rowIndex === void 0 || this.state.colIndex === void 0)
        throw new Error(
          "Attempted to drop table row or column, but no table block was hovered prior."
        );
      e.preventDefault();
      const { draggingState: o, colIndex: t, rowIndex: n } = this.state, r = this.state.block.content.columnWidths;
      if (o.draggedCellOrientation === "row") {
        if (!se(
          this.state.block,
          o.originalIndex,
          n
        ))
          return !1;
        const i = Ie(
          this.state.block,
          o.originalIndex,
          n
        );
        this.editor.updateBlock(this.state.block, {
          type: "table",
          content: {
            ...this.state.block.content,
            rows: i
          }
        });
      } else {
        if (!re(
          this.state.block,
          o.originalIndex,
          t
        ))
          return !1;
        const i = Pe(
          this.state.block,
          o.originalIndex,
          t
        ), [a] = r.splice(o.originalIndex, 1);
        r.splice(t, 0, a), this.editor.updateBlock(this.state.block, {
          type: "table",
          content: {
            ...this.state.block.content,
            columnWidths: r,
            rows: i
          }
        });
      }
      return this.editor.setTextCursorPosition(this.state.block.id), !0;
    });
    this.editor = e, this.pmView = o, this.emitUpdate = () => {
      if (!this.state)
        throw new Error("Attempting to update uninitialized image toolbar");
      t(this.state);
    }, o.dom.addEventListener("mousemove", this.mouseMoveHandler), o.dom.addEventListener("mousedown", this.viewMousedownHandler), window.addEventListener("mouseup", this.mouseUpHandler), o.root.addEventListener(
      "dragover",
      this.dragOverHandler
    ), o.root.addEventListener(
      "drop",
      this.dropHandler
    );
  }
  // Updates drag handles when the table is modified or removed.
  update() {
    var n;
    if (!this.state || !this.state.show)
      return;
    if (this.state.block = this.editor.getBlock(this.state.block.id), !this.state.block || this.state.block.type !== "table" || // when collaborating, the table element might be replaced and out of date
    // because yjs replaces the element when for example you change the color via the side menu
    !((n = this.tableElement) != null && n.isConnected)) {
      this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate();
      return;
    }
    const { height: e, width: o } = Be(
      this.state.block
    );
    this.state.rowIndex !== void 0 && this.state.colIndex !== void 0 && (this.state.rowIndex >= e && (this.state.rowIndex = e - 1), this.state.colIndex >= o && (this.state.colIndex = o - 1));
    const t = this.tableElement.querySelector("tbody");
    if (!t)
      throw new Error(
        "Table block does not contain a 'tbody' HTML element. This should never happen."
      );
    if (this.state.rowIndex !== void 0 && this.state.colIndex !== void 0) {
      const i = t.children[this.state.rowIndex].children[this.state.colIndex];
      i ? this.state.referencePosCell = i.getBoundingClientRect() : (this.state.rowIndex = void 0, this.state.colIndex = void 0);
    }
    this.state.referencePosTable = t.getBoundingClientRect(), this.emitUpdate();
  }
  destroy() {
    this.pmView.dom.removeEventListener("mousemove", this.mouseMoveHandler), window.removeEventListener("mouseup", this.mouseUpHandler), this.pmView.dom.removeEventListener("mousedown", this.viewMousedownHandler), this.pmView.root.removeEventListener(
      "dragover",
      this.dragOverHandler
    ), this.pmView.root.removeEventListener(
      "drop",
      this.dropHandler
    );
  }
}
const O = new D("TableHandlesPlugin"), mo = x(({ editor: s }) => {
  let e;
  const o = H(void 0);
  return {
    key: "tableHandles",
    store: o,
    prosemirrorPlugins: [
      new B({
        key: O,
        view: (t) => (e = new Dt(s, t, (n) => {
          o.setState(
            n.block ? {
              ...n,
              draggingState: n.draggingState ? { ...n.draggingState } : void 0
            } : void 0
          );
        }), e),
        // We use decorations to render the drop cursor when dragging a table row
        // or column. The decorations are updated in the `dragOverHandler` method.
        props: {
          decorations: (t) => {
            if (e === void 0 || e.state === void 0 || e.state.draggingState === void 0 || e.tablePos === void 0)
              return;
            const n = e.state.draggingState.draggedCellOrientation === "row" ? e.state.rowIndex : e.state.colIndex;
            if (n === void 0)
              return;
            const r = [], { block: i, draggingState: a } = e.state, { originalIndex: c, draggedCellOrientation: l } = a;
            if (n === c || !i || l === "row" && !se(i, c, n) || l === "col" && !re(i, c, n))
              return V.create(t.doc, r);
            const m = t.doc.resolve(e.tablePos + 1);
            return e.state.draggingState.draggedCellOrientation === "row" ? q(
              e.state.block,
              n
            ).forEach(({ row: f, col: h }) => {
              const g = t.doc.resolve(
                m.posAtIndex(f) + 1
              ), d = t.doc.resolve(
                g.posAtIndex(h) + 1
              ), p = d.node(), w = d.pos + (n > c ? p.nodeSize - 2 : 0);
              r.push(
                // The widget is a small bar which spans the width of the cell.
                M.widget(w, () => {
                  const y = document.createElement("div");
                  return y.className = "bn-table-drop-cursor", y.style.left = "0", y.style.right = "0", n > c ? y.style.bottom = "-2px" : y.style.top = "-3px", y.style.height = "4px", y;
                })
              );
            }) : X(
              e.state.block,
              n
            ).forEach(({ row: f, col: h }) => {
              const g = t.doc.resolve(
                m.posAtIndex(f) + 1
              ), d = t.doc.resolve(
                g.posAtIndex(h) + 1
              ), p = d.node(), w = d.pos + (n > c ? p.nodeSize - 2 : 0);
              r.push(
                // The widget is a small bar which spans the height of the cell.
                M.widget(w, () => {
                  const y = document.createElement("div");
                  return y.className = "bn-table-drop-cursor", y.style.top = "0", y.style.bottom = "0", n > c ? y.style.right = "-2px" : y.style.left = "-3px", y.style.width = "4px", y;
                })
              );
            }), V.create(t.doc, r);
          }
        }
      })
    ],
    /**
     * Callback that should be set on the `dragStart` event for whichever element
     * is used as the column drag handle.
     */
    colDragStart(t) {
      if (e === void 0 || e.state === void 0 || e.state.colIndex === void 0)
        throw new Error(
          "Attempted to drag table column, but no table block was hovered prior."
        );
      e.state.draggingState = {
        draggedCellOrientation: "col",
        originalIndex: e.state.colIndex,
        mousePos: t.clientX
      }, e.emitUpdate(), s.transact(
        (n) => n.setMeta(O, {
          draggedCellOrientation: e.state.draggingState.draggedCellOrientation,
          originalIndex: e.state.colIndex,
          newIndex: e.state.colIndex,
          tablePos: e.tablePos
        })
      ), !s.headless && (ee(s.prosemirrorView.root), t.dataTransfer.setDragImage(k, 0, 0), t.dataTransfer.effectAllowed = "move");
    },
    /**
     * Callback that should be set on the `dragStart` event for whichever element
     * is used as the row drag handle.
     */
    rowDragStart(t) {
      if (e.state === void 0 || e.state.rowIndex === void 0)
        throw new Error(
          "Attempted to drag table row, but no table block was hovered prior."
        );
      e.state.draggingState = {
        draggedCellOrientation: "row",
        originalIndex: e.state.rowIndex,
        mousePos: t.clientY
      }, e.emitUpdate(), s.transact(
        (n) => n.setMeta(O, {
          draggedCellOrientation: e.state.draggingState.draggedCellOrientation,
          originalIndex: e.state.rowIndex,
          newIndex: e.state.rowIndex,
          tablePos: e.tablePos
        })
      ), !s.headless && (ee(s.prosemirrorView.root), t.dataTransfer.setDragImage(k, 0, 0), t.dataTransfer.effectAllowed = "copyMove");
    },
    /**
     * Callback that should be set on the `dragEnd` event for both the element
     * used as the row drag handle, and the one used as the column drag handle.
     */
    dragEnd() {
      if (e.state === void 0)
        throw new Error(
          "Attempted to drag table row, but no table block was hovered prior."
        );
      e.state.draggingState = void 0, e.emitUpdate(), s.transact((t) => t.setMeta(O, null)), !s.headless && It(s.prosemirrorView.root);
    },
    /**
     * Freezes the drag handles. When frozen, they will stay attached to the same
     * cell regardless of which cell is hovered by the mouse cursor.
     */
    freezeHandles() {
      e.menuFrozen = !0;
    },
    /**
     * Unfreezes the drag handles. When frozen, they will stay attached to the
     * same cell regardless of which cell is hovered by the mouse cursor.
     */
    unfreezeHandles() {
      e.menuFrozen = !1;
    },
    getCellsAtRowHandle(t, n) {
      return q(t, n);
    },
    /**
     * Get all the cells in a column of the table block.
     */
    getCellsAtColumnHandle(t, n) {
      return X(t, n);
    },
    /**
     * Sets the selection to the given cell or a range of cells.
     * @returns The new state after the selection has been set.
     */
    setCellSelection(t, n, r = n) {
      if (!e)
        throw new Error("Table handles view not initialized");
      const i = t.doc.resolve(e.tablePos + 1), a = t.doc.resolve(
        i.posAtIndex(n.row) + 1
      ), c = t.doc.resolve(
        // No need for +1, since CellSelection expects the position before the cell
        a.posAtIndex(n.col)
      ), l = t.doc.resolve(
        i.posAtIndex(r.row) + 1
      ), m = t.doc.resolve(
        // No need for +1, since CellSelection expects the position before the cell
        l.posAtIndex(r.col)
      ), u = t.tr;
      return u.setSelection(
        new it(c, m)
      ), t.apply(u);
    },
    /**
     * Adds a row or column to the table using prosemirror-table commands
     */
    addRowOrColumn(t, n) {
      s.exec((r, i) => {
        const a = this.setCellSelection(
          r,
          n.orientation === "row" ? { row: t, col: 0 } : { row: 0, col: t }
        );
        return n.orientation === "row" ? n.side === "above" ? ot(a, i) : nt(a, i) : n.side === "left" ? st(a, i) : rt(a, i);
      });
    },
    /**
     * Removes a row or column from the table using prosemirror-table commands
     */
    removeRowOrColumn(t, n) {
      return n === "row" ? s.exec((r, i) => {
        const a = this.setCellSelection(r, {
          row: t,
          col: 0
        });
        return et(a, i);
      }) : s.exec((r, i) => {
        const a = this.setCellSelection(r, {
          row: 0,
          col: t
        });
        return tt(a, i);
      });
    },
    /**
     * Merges the cells in the table block.
     */
    mergeCells(t) {
      return s.exec((n, r) => {
        const i = t ? this.setCellSelection(
          n,
          t.relativeStartCell,
          t.relativeEndCell
        ) : n;
        return Ze(i, r);
      });
    },
    /**
     * Splits the cell in the table block.
     * If no cell is provided, the current cell selected will be split.
     */
    splitCell(t) {
      return s.exec((n, r) => {
        const i = t ? this.setCellSelection(n, t) : n;
        return Qe(i, r);
      });
    },
    /**
     * Gets the start and end cells of the current cell selection.
     * @returns The start and end cells of the current cell selection.
     */
    getCellSelection() {
      return s.transact((t) => {
        const n = t.selection;
        let r = n.$from, i = n.$to;
        if (W(n)) {
          const { ranges: d } = n;
          d.forEach((p) => {
            r = p.$from.min(r ?? p.$from), i = p.$to.max(i ?? p.$to);
          });
        } else if (r = t.doc.resolve(
          n.$from.pos - n.$from.parentOffset - 1
        ), i = t.doc.resolve(
          n.$to.pos - n.$to.parentOffset - 1
        ), r.pos === 0 || i.pos === 0)
          return;
        const a = t.doc.resolve(
          r.pos - r.parentOffset - 1
        ), c = t.doc.resolve(i.pos - i.parentOffset - 1), l = t.doc.resolve(a.pos - a.parentOffset - 1), m = r.index(a.depth), u = a.index(l.depth), f = i.index(c.depth), h = c.index(l.depth), g = [];
        for (let d = u; d <= h; d++)
          for (let p = m; p <= f; p++)
            g.push({ row: d, col: p });
        return {
          from: {
            row: u,
            col: m
          },
          to: {
            row: h,
            col: f
          },
          cells: g
        };
      });
    },
    /**
     * Gets the direction of the merge based on the current cell selection.
     *
     * Returns undefined when there is no cell selection, or the selection is not within a table.
     */
    getMergeDirection(t) {
      return s.transact((n) => {
        const r = W(n.selection) ? n.selection : void 0;
        if (!r || !t || // Only offer the merge button if there is more than one cell selected.
        r.ranges.length <= 1)
          return;
        const i = this.getCellSelection();
        if (i)
          return Oe(i.from, i.to, t) ? "vertical" : "horizontal";
      });
    },
    cropEmptyRowsOrColumns(t, n) {
      return Te(t, n);
    },
    addRowsOrColumns(t, n, r) {
      return De(t, n, r);
    }
  };
}), te = new D("trailingNode"), po = x(() => ({
  key: "trailingNode",
  prosemirrorPlugins: [
    new B({
      key: te,
      appendTransaction: (s, e, o) => {
        const { doc: t, tr: n, schema: r } = o, i = te.getState(o), a = t.content.size - 2, c = r.nodes.blockContainer, l = r.nodes.paragraph;
        if (i)
          return n.insert(
            a,
            c.create(void 0, l.create())
          );
      },
      state: {
        init: (s, e) => {
        },
        apply: (s, e) => {
          if (!s.docChanged)
            return e;
          let o = s.doc.lastChild;
          if (!o || o.type.name !== "blockGroup")
            throw new Error("Expected blockGroup");
          if (o = o.lastChild, !o || o.type.name !== "blockContainer")
            return !0;
          const t = o.firstChild;
          if (!t)
            throw new Error("Expected blockContent");
          return o.nodeSize > 4 || t.type.spec.content !== "inline*";
        }
      }
    })
  ]
}));
export {
  Zt as B,
  to as D,
  eo as F,
  no as H,
  so as L,
  ao as N,
  lo as P,
  St as S,
  Dt as T,
  ro as V,
  F as Y,
  oo as a,
  io as b,
  co as c,
  uo as d,
  mo as e,
  mt as f,
  po as g,
  ut as h,
  me as i,
  ho as j,
  fe as k,
  vt as l,
  Et as s,
  O as t
};
//# sourceMappingURL=TrailingNode-Dyk86U-N.js.map
